import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { colors } from "../../../../theme/colors";
import { useEffect, useState } from "react";
import PetsIcon from "@mui/icons-material/Pets";
import { ProductCard } from "../ProductCard";

interface Props {
  sectionList: any[];
  greyTitle: string;
  purpleSubTitle: string;
  vermais?: string;
}

export function CarrouselWith4cards({
  sectionList,
  greyTitle,
  purpleSubTitle,
  vermais,
}: Props) {
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const [products, setProducts] = useState([] as any);

  const convert = () => {
    const newCardsArray = [];
    let arrayToPush = [];
    if (sectionList?.length <= 2) {
      sectionList.forEach((item, index) => {
        newCardsArray.push([item]);
      });
      setProducts(newCardsArray);
    } else {
      if (isMobile) {
        sectionList.forEach((item, index) => {
          newCardsArray.push([item]);
        });
        setProducts(newCardsArray);
      } else if (isSmalldesktop) {
        sectionList.forEach((item, index) => {
          if (index <= 1) {
            arrayToPush.push(item);
          }
          if (index > 1 && index <= 3) {
            if (index === 2) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 3 && index <= 5) {
            if (index === 4) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 5 && index <= 7) {
            if (index === 6) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 7 && index <= 9) {
            if (index === 8) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 9 && index <= 11) {
            if (index === 10) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 11) {
            newCardsArray.push(arrayToPush);
            arrayToPush = [];
          }
        });
        setProducts(newCardsArray);
      } else {
        sectionList.forEach((item, index) => {
          if (index <= 3) {
            arrayToPush.push(item);
          }
          if (index > 3 && index <= 6) {
            if (index === 4) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index >= 7 && index <= 11) {
            if (index === 8) {
              newCardsArray.push(arrayToPush);
              arrayToPush = [];
            }
            arrayToPush.push(item);
          }
          if (index > 11) {
            newCardsArray.push(arrayToPush);
            arrayToPush = [];
          }
        });
        setProducts(newCardsArray);
      }
    }
  };

  useEffect(() => {
    if (sectionList?.length > 0) {
      convert();
    }
    // eslint-disable-next-line
  }, [sectionList, isMobile, isSmalldesktop]);

  const Card = ({
    item,
  }: {
    item: Omit<ProductData, "Manufacturers" | "Versions" | "Origin">;
  }) => <ProductCard item={item} />;

  return (
    <Box
      width={"95%"}
      margin={"auto"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"flex-start"}
        flexDirection={"column"}
        mt={10}
        mb={5}
        pl={5}
      >
        <Typography
          width={isMobile ? 300 : "100%"}
          fontSize={isMobile ? 12 : 16}
          fontWeight={600}
          color={colors.textGrey[500]}
        >
          {greyTitle}
        </Typography>
        <Typography
          width={isMobile ? 300 : "100%"}
          fontSize={isMobile ? 18 : 24}
          color={colors.purple[500]}
          fontWeight={700}
        >
          {purpleSubTitle}
        </Typography>
      </Box>
      <Box width={isSmalldesktop ? "100%" : "90%"}>
        <Carousel
          next={() => {
            /* Do stuff */
          }}
          prev={() => {
            /* Do other stuff */
          }}
          autoPlay
          interval={10000}
          animation="slide"
          duration={1000}
          swipe
          navButtonsAlwaysVisible
          navButtonsProps={{
            style: {
              background: "#FFFFFF",
              color: colors.purple[500],
              border: `1px solid ${colors.purple[500]}`,
              marginTop: -100,
            },
          }}
          sx={{
            width: "100%",
            "& .css-1l7c0cy > div > div > div": {
              display: "flex",
              justifyContent: "center",
              overflow: "visible",
            },
          }}
          NextIcon={<PetsIcon sx={{ transform: "rotate(90deg)" }} />}
          PrevIcon={<PetsIcon sx={{ transform: "rotate(270deg)" }} />}
        >
          {products.map((item1, index) => (
            <Box display="flex" gap={2} key={index} mt={5}>
              {item1?.map((item2) => (
                <Card item={item2} />
              ))}
            </Box>
          ))}
        </Carousel>
      </Box>
      <Button variant={"outlined"} sx={{ mt: 5 }}>
        <Link
          to={`/products?tab=1&${vermais}`}
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Ver mais <span style={{ marginLeft: 5 }}>{">"}</span>
        </Link>
      </Button>
    </Box>
  );
}
